import { APP_URL } from './config';
import Helpers from './helper';

export const getPdfUrl = (pdfPath: string): string => {
    
    if (pdfPath.startsWith('http')) {
        return pdfPath;
    }

    let baseUrl = '';
    if (
        !Helpers.isEmptyOrNull(APP_URL) &&
        (APP_URL.startsWith('http://') || APP_URL.startsWith('https://'))
    ) {
        baseUrl = APP_URL;
    } else if (typeof window !== 'undefined') {
        baseUrl = window.location.origin;
    }
    const pdfUrl = baseUrl + pdfPath;
    return pdfUrl;
};

export const getGoogleDocsViewerUrl = (pdfPath: string): string => {
    const pdfUrl = getPdfUrl(pdfPath);
    const baseUrl = `https://docs.google.com/gview?url=${encodeURIComponent(
        pdfUrl
    )}&embedded=true`;
    
    return `${baseUrl}&v=${Date.now()}`;
};
